import {IAdnetState} from "../../interfaces";
import {List} from "immutable";

export const initialAdnetState: IAdnetState = {
    customers: null,
    rates: null,
    pairs: null,
    packages: null,
    targets: null,
    targets_search: null,
    reports: null,
    payments: null,
    transfers: null
};


